/* eslint-disable arrow-body-style */
import React, { useContext, useMemo, useState } from 'react';
import classNames from 'classnames';
import CommonTitle from '@home/pages/studio/components/CommonTitle';
import GPTReport from '../GPTReport';
import './index.scss';
import { StudioContext } from '@home/pages/studio/context';

export interface IProps {
  id?: string;
  index: number;
  refArray?: any[];
  scrollStyle?: React.CSSProperties;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  filter?: any;
  titleConfig?: {
    className?: string;
    style?: React.CSSProperties;
  };
  // 是否舆情跳转
  isOpinionsUrl?: boolean;
  gptConfig?: {
    className?: string;
    style?: React.CSSProperties;
  };
  filterCond?: any;
}


export default function GPTWrap(props: IProps) {
  const { className, style, children, filter, titleConfig, gptConfig, id, index, refArray, scrollStyle,isOpinionsUrl, filterCond, ...resetProps } = props || {};
  const [gptSummaryData, setGptSummaryData] = useState<{ id: number; gpt_summary: string; }>();
  const [refreshKey, setRefreshKey] = useState(true);
  const [gptLoading, setGptLoading] = useState(true);
  const [gptShowChildren, setGptShowChildren] = useState(false);
  const { editPermission } = useContext(StudioContext);
  
  const filterValue = useMemo(() => {
    if(!filterCond){
      return {};
    }
    return {
      ...(filter || {}),
      startTime: filter?.start_time?.split(' ')?.[0] || filter?.start_time,
      endTime: filter?.end_time?.split(' ')?.[0] || filter?.end_time,
      social_media_by_account: filterCond?.social_media_by_account || undefined,
    };
  }, [filter, filterCond]);

  const getGptSummaryData = (data:{ id: number; gpt_summary: string; }) => {
    setGptSummaryData(data);
  };

  const getGptLoading = (val: boolean) => {
    setGptLoading(val);
  };

  const getGptShowChildren = (val: boolean) => {
    setGptShowChildren(val);
  };

  // 无编辑权限，gpt加载中，gpt展示get gpt summary按钮，gpt展示计算中状态（无数据）这几种情况下隐藏编辑按钮
  const hideRightSlot = gptLoading || gptShowChildren || !editPermission || !gptSummaryData?.gpt_summary;

  return (
    <div
      className={classNames(
        'dbh-studio-opinions-gpt-wrap',
        { 'dbh-studio-opinions-gpt-wrap--no-right-slot': hideRightSlot },
        className,
      )}
      style={{ ...style, ...scrollStyle }}
      id={id}
      data-scroll-index={index}
      ref={refArray?.[index]}
    >
      <CommonTitle
        refresh={() => { setRefreshKey(!refreshKey) }}
        {...(resetProps || {})}
        {...(titleConfig || {})}
        data={{
          ...(resetProps?.data || {}),
          gptSummaryData,
        }}
        isOpinionsUrl={isOpinionsUrl}
        filter={filterValue}
        hideRightSlot={hideRightSlot}
      />

      <GPTReport
        key={refreshKey}
        getGptSummaryData={getGptSummaryData}
        getGptShowChildren={getGptShowChildren}
        getGptLoading={getGptLoading}
        // gptSummaryData={gptSummaryData}
        {...(resetProps || {})}
        {...(gptConfig || {})}
        filter={filterValue}
      />

    </div>
  );
}
